import * as React from 'react';
import { parseCookies } from 'nookies';
import { COOKIES_CONFIG } from '../constants/cookies.js';
import { useRouter } from '../contexts/router-context/router-context.js';
import { formatFullStoryKeys } from './utils.js';

const {
  TRACKING_ID
} = COOKIES_CONFIG;
const getRouteProperties = query => {
  const prefixedQueryParams = {};
  Object.entries(query).forEach(([key, value]) => {
    prefixedQueryParams[`qp_${key}`] = value;
  });
  return prefixedQueryParams;
};
const AnalyticsContext = /*#__PURE__*/React.createContext({
  track: () => {}
});
const AnalyticsProvider = ({
  children,
  userId,
  projectName,
  userClaims = {}
}) => {
  const {
    query
  } = useRouter();
  const cookies = parseCookies();
  const trackingId = cookies[TRACKING_ID.name];
  const rootTrack = React.useCallback((eventType, trackingData) => {
    const properties = {
      trackingId,
      userId,
      projectName,
      ...trackingData,
      ...userClaims,
      ...getRouteProperties(query)
    };
    if (eventType === 'page_view') {
      // @ts-ignore
      if (!window._landingPage) {
        // @ts-ignore
        window._landingPage = properties.page;
        // @ts-ignore
        properties.landingPage = properties.page;
        // @ts-ignore
        window.mixpanel?.register({
          landingPage: properties.page
        });
        properties.isFirstPageView = true;
      }
      const {
        page,
        ...restProperties
      } = properties;
      // @ts-ignore
      window.FS?.setVars?.('page', {
        pageName: page,
        ...formatFullStoryKeys(restProperties)
      });
    }
    if (eventType === 'modal_view') {
      // @ts-ignore
      window.FS?.event?.(eventType, formatFullStoryKeys(properties));
    }
    // @ts-ignore
    window.mixpanel?.track(eventType, properties);
  }, [query, trackingId, userClaims, userId]);
  return /*#__PURE__*/React.createElement(AnalyticsContext.Provider, {
    value: {
      track: rootTrack
    }
  }, children);
};
const useAnalytics = () => {
  const analyticsContext = React.useContext(AnalyticsContext);
  if (analyticsContext === null) {
    throw new Error('useAnalytics must be used within an AnalyticsClient');
  }
  return analyticsContext;
};

export { AnalyticsProvider, getRouteProperties, useAnalytics };
